import React, { useMemo } from 'react';
import './GradientBackground.css';

// Light theme: orange → coral → violet blobs on near-white.
function randomHue(base, spread = 15) {
  return (base + (Math.random() - 0.5) * spread * 2 + 360) % 360;
}

function hsl(h, s, l) {
  return `hsl(${h}, ${s}%, ${l}%)`;
}

function generatePalette() {
  const spots = [
    { h: 22,  s: 90, l: 62 }, // bright orange
    { h: 268, s: 80, l: 60 }, // violet
    { h: 350, s: 88, l: 62 }, // coral-red
  ];
  return spots.map(({ h, s, l }) => hsl(randomHue(h), s, l));
}

export default function GradientBackground() {
  const [c1, c2, c3] = useMemo(() => generatePalette(), []);

  // Three soft focal points: pink top-left, indigo bottom-right, violet centre
  const meshStyle = {
    background: [
      `radial-gradient(ellipse 65% 60% at 8%  8%,  ${c1} 0%, transparent 65%)`,
      `radial-gradient(ellipse 60% 65% at 88% 88%, ${c3} 0%, transparent 65%)`,
      `radial-gradient(ellipse 52% 52% at 52% 42%, ${c2} 0%, transparent 60%)`,
    ].join(', '),
  };

  const sparkles = useMemo(() =>
    Array.from({ length: 15 }, (_, i) => ({
      id: i,
      style: {
        top:               `${Math.random() * 95}%`,
        left:              `${Math.random() * 95}%`,
        animationDelay:    `${(Math.random() * 5).toFixed(1)}s`,
        animationDuration: `${(3 + Math.random() * 3).toFixed(1)}s`,
      },
    }))
  , []);

  return (
    <div className="gradient-bg" aria-hidden="true">
      {/* Slow-drifting glow blobs — sit behind the mesh */}
      <div className="gradient-bg__blob gradient-bg__blob--1" />
      <div className="gradient-bg__blob gradient-bg__blob--2" />
      <div className="gradient-bg__blob gradient-bg__blob--3" />
      {/* Colour mesh */}
      <div className="gradient-bg__mesh" style={meshStyle} />
      {/* Twinkling sparkles */}
      {sparkles.map(s => (
        <div key={s.id} className="gradient-bg__sparkle" style={s.style} />
      ))}
    </div>
  );
}
